import React, { FC } from 'react';

import { SchedulingSection } from 'src/components/scheduling2';

import { IProperty } from '../../../../interfaces/Property';
import { IPropertyError } from '../../../../interfaces/PropertyError';
import { IScheduledJobConfiguration } from '../../../../interfaces/ScheduledJobConfiguration';

interface ISchedulingSettingsV2Props {
	property: IProperty;
	propertyError?: IPropertyError;
	setProperty: (props: IScheduledJobConfiguration | undefined) => void;
}

export const SchedulingSettingsV2: FC<ISchedulingSettingsV2Props> = ({
	property,
	propertyError,
	setProperty
}: ISchedulingSettingsV2Props) => {
	const initialConfig = property.scheduledJobConfiguration;

	const onConfigChange = (config: IScheduledJobConfiguration): void => {
		const scheduledJobConfiguration = config.active ? config : undefined;
		setProperty(scheduledJobConfiguration);
	};

	return (
		<SchedulingSection
			initialConfig={initialConfig}
			onConfigChange={onConfigChange}
			error={propertyError}
		/>
	);
};
